import React from 'react';
import './SettingsLayout.css';

const tabs = [
  { key: 'profile', label: 'Profile' },
  { key: 'team', label: 'Team & Access' },
  { key: 'database-config', label: 'Database Configuration', databaseConfigOnly: true },
  { key: 'owner', label: 'Owner Tools', ownerOnly: true },
  { key: 'support', label: 'Support' },
];

const SettingsNav = ({ activeTab, onChange, isOwner, canAccessDatabaseConfig }) => {
  return (
    <div className="settings-nav">
      {tabs
        .filter((t) => !t.ownerOnly || isOwner)
        .filter((t) => !t.databaseConfigOnly || canAccessDatabaseConfig)
        .map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={`settings-tab ${activeTab === tab.key ? 'active' : ''}`}
            onClick={() => onChange(tab.key)}
          >
            {tab.label}
          </button>
        ))}
    </div>
  );
};

export default SettingsNav;
